import type { IProtocolTransfer, TransferKind } from '@/types/Chat'

const REMOVED_CHANNEL_LABEL = 'canal removido'

/** Nome de exibição do canal numa transferência; snapshot null → "canal removido". */
export function transferChannelLabel(name: string | null): string {
  return name ?? REMOVED_CHANNEL_LABEL
}

/**
 * Natureza da troca de canal. Entry sem `kind` (gravada antes do deploy da onda 2)
 * → `transfer`, o mesmo default do back. NÃO inferir de `by_user_id === 'System'`:
 * entries antigas trazem `System` até em roubo — é o bug que o `kind` corrigiu (§16.1).
 */
export function transferKind(transfer: IProtocolTransfer): TransferKind {
  return transfer.kind ?? 'transfer'
}

/** Hora local HH:MM do `at` (epoch segundos). */
export function formatTransferTime(at: number): string {
  return new Date(at * 1000).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
}

/** Data curta `dd/mm HH:MM` do `at` (epoch segundos) — linha do painel. */
export function formatTransferDateTime(at: number): string {
  const date = new Date(at * 1000)
  const day = date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
  return `${day} ${formatTransferTime(at)}`
}

/** Nome de exibição do ator da transferência; snapshot ausente/null → fallback pro username. */
export function transferActorName(transfer: IProtocolTransfer): string {
  return transfer.by_user_name ?? transfer.by_username
}
